import { ToastContainer, Slide } from 'react-toastify';
import IconSvg from "@components/core/IconSvg";
import Button from "@components/core/Button";

const iconsTypes = {
  success: "circle-success-tick",
  error: "circle-error",
  warning: "circle-warning",
  info: "circle-info",
};

const Icon = ({ type }) => (
  <div style={{ marginTop: "-4px" }}>
    <IconSvg name={iconsTypes[type]} />
  </div>
);

const CloseButton = ({ closeToast }) => (
  <Button
    variant="ghost-dark"
    className=""
    style={{ marginTop: "-12px", marginRight: "-12px" }}
    size="sm"
    leftIconName="close"
    onClick={closeToast}
  />
);

function ToastConfig() {
  return (
    <ToastContainer
      position="top-right"
      hideProgressBar
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable={false}
      pauseOnHover
      closeButton={CloseButton}
      icon={Icon}
      transition={Slide}
      limit={1}
    />
  );
}

export default ToastConfig;
